import { render, staticRenderFns } from "./ParticipantShortInfo.vue?vue&type=template&id=82edce7a&"
import script from "./ParticipantShortInfo.vue?vue&type=script&lang=js&"
export * from "./ParticipantShortInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantShortInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports